module.exports = __webpack_public_path__ + "static/media/ease-of-experience-metric-small.cefba6f2.svg";